<div class="row">
    <div class="col-12 container-ambiente" id="container-ambiente">
        <div class="strumenti">
            <div class="btn-group-vertical" role="group" aria-label="Toolbar">
                <button type="button" id="strumenti-cross" [ngClass]="attivaPulsante(bAttivaCross)" (click)="attivaCross()">
                    <i class="fas fa-crosshairs fa-lg"></i>
                </button>
                <button type="button" id="strumenti-padding-end" class="btn btn-outline-info btn-sm">
                    <i class="fas fa-sign-in-alt"></i>
                </button>
            </div>
        </div>
        <div class="container-scroll" id="container-scroll">
            <div class="container-strumenti" id="divGrafico">
                <div class="grafico" [style.width]="wGrafico" [style.height]="hGrafico" id="grafico">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" id="svg-grafico">
                        <text id="cross-time" x="10" y="10" fill="black"></text>
                    </svg>
                </div>
            </div>
            <div class="labels" id="labels">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" id="svg-labels">
                    <text id="cross-value" x="10" y="10" fill="black"></text>
                </svg>
            </div>
        </div>
    </div>
</div>